/**
 * Tech card tracking + the design switch hook.
 *
 * Events are ordinary trackClick calls (PostHog `utech_click` + the
 * site_events mirror), named `techcard_*`:
 *   techcard_expand        {tech_id, rank, surface}
 *   techcard_collapse      {tech_id, surface}
 *   techcard_tab           {tab, tech_id}
 *   techcard_similar_click {tech_id, target_id, rank}
 *   techcard_university_click / techcard_country_click {tech_id}
 *   techcard_contact       {tech_id, surface, locked?}
 *   techcard_ipintel_open  {tech_id, surface}
 *   techcard_share         {channel, tech_id, surface}
 *   techcard_share_open    {tech_id, surface}
 *   techcard_bookmark      {on, tech_id, surface}
 *   techcard_locked_click  {section, reason, tech_id, surface}
 *   techcard_load_error    {tech_id, status}
 * In-platform IP Intel actions reuse the public page's ipintel_* names with
 * {surface: 'platform', entry: 'techcard', tech_id} so Admin → IP Intel
 * counts them (see IpIntelOrderModal).
 */

import { useEffect, useState } from 'react';
import { trackClick } from '../../utils/analytics';
import { initialDesign, loadTechCardDesign, onDesignChange, TechCardDesign } from './api';

export const tcTrack = (action: string, props?: Record<string, unknown>): void => {
  // Analytics must never break a click.
  try { trackClick(action, props); } catch { /* ignore */ }
};

/** accordion | legacy — Admin → Tech URL pages → Sections & access. */
export function useTechCardDesign(): TechCardDesign {
  const [design, setDesign] = useState<TechCardDesign>(initialDesign);
  useEffect(() => {
    let live = true;
    const off = onDesignChange(d => { if (live) setDesign(d); });
    loadTechCardDesign().then(d => { if (live) setDesign(d); });
    return () => { live = false; off(); };
  }, []);
  return design;
}
